module.exports = InternalShared('InternalShared/Events/FieldDragStarted');